export default "__VITE_ASSET__BGb26n4G__"